import {
  Breadcrumb,
  Checkbox,
  Col,
  List,
  Row,
  Skeleton,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  HomeOutlined,
  FolderOpenOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { workOrderList } from "./data";
import WorkOrderInfo from "./components/workOrderInfo";
import AssignWorkOrder from "./components/assignWorkOrder";
import UrgentWorkOrder from "./components/urgentWorkOrder";
import EstimateProcess from "./components/estimateProcess";
import OwnerApprovalNeeded from "./components/ownerApprovalNeeded";
import CityCitation from "./components/cityCitation";
import DelCityInspection from "./components/delCityInspection";
import SectionEight from "./components/sectionEight";
import CancelWorkOrder from "./components/cancelWorkOrder";
import WorkOrderCompleted from "./components/workOrderCompleted";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../firebase";
const { Text } = Typography;

function WorkOrderFollowUp({ data, alreadyCheckedItems }) {
  const { id } = useParams();

  const [itemId, setItemId] = useState(1);

  const [listId, setListId] = useState(null);
  const [checkedItems, setCheckedItems] = useState(alreadyCheckedItems || {});

  useEffect(() => {
    if (alreadyCheckedItems) {
      setCheckedItems(alreadyCheckedItems);
    }
  }, [alreadyCheckedItems]);

  const handleOnClick = (index, listId) => {
    setItemId(index);
    setListId(listId);
  };

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");
  const updateAssignedWorkItemListStatus = async (targetDocId, idStatusMap) => {
    const targetDocRef = doc(assignedCollectionRef, targetDocId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status: idStatusMap[item.id.toString()]
                ? "completed"
                : "incompleted",
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  useEffect(() => {
    const length = Object.keys(checkedItems).length;
    if (length) {
      updateAssignedWorkItemListStatus(id, checkedItems);
    }
  }, [checkedItems]);

  const handleCheckBoxClick = (e, index, itemId) => {
    // Prevent the item click from being triggered when clicking the checkbox
    e.stopPropagation();
    // Update the checked state of this item
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [itemId.toString()]: !prevCheckedItems[itemId.toString()],
    }));
  };
  return (
    <div className="move-out">
      <Row gutter={[16, 0]}>
        <Col span={8}>
          <Row gutter={[0, 24]} className="move-out-container">
            <Col span={24}>
              <span className="move-out-icon">🚚</span>
            </Col>
            <Col span={24}>
              <Breadcrumb>
                <Breadcrumb.Item className="item-hover-effect">
                  <HomeOutlined /> <span>Library</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FolderOpenOutlined />{" "}
                  <span>Property Management Process</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="item-hover-effect">
                  <FileOutlined /> <span>G. Work Order Follow Up</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col span={24}>
              <Row>
                <Col>
                  <p className="heading-para">
                    G. Work Order Follow Up 2:46PM workflow run
                  </p>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <List
                className="list-container"
                itemLayout="horizontal"
                dataSource={data?.workItemList}
                bordered
                renderItem={(item, index) => (
                  <List.Item
                    className="list-item"
                    onClick={() => handleOnClick(item?.id, data?.docId)}
                  >
                    <Skeleton
                      avatar
                      title={false}
                      loading={item.loading}
                      active
                    >
                      <List.Item.Meta
                        avatar={
                          <div className="item-container">
                            <span>{index + 1}. </span>
                            {item.checkBox && (
                              <Checkbox
                                onClick={(e) =>
                                  handleCheckBoxClick(e, index, item.id)
                                }
                                checked={!!checkedItems[item.id.toString()]}
                              ></Checkbox>
                            )}
                            <Text
                              strong={!item.checkBox && true}
                              delete={!!checkedItems[item.id.toString()]}
                            >
                              {item?.title}
                            </Text>
                          </div>
                        }
                      />
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Col>
        <Col span={16} className="right-container">
          {itemId === 1 && (
            <WorkOrderInfo
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 2 && (
            <AssignWorkOrder
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 3 && (
            <UrgentWorkOrder
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 4 && (
            <EstimateProcess
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 5 && (
            <OwnerApprovalNeeded
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 6 && (
            <CityCitation
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 7 && (
            <DelCityInspection
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 8 && (
            <SectionEight
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 9 && (
            <CancelWorkOrder
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
          {itemId === 10 && (
            <WorkOrderCompleted
              alreadyCheckedItems={checkedItems}
              itemId={itemId}
              listId={listId}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default WorkOrderFollowUp;
